import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CircularProgress from 'material-ui/CircularProgress';

import apiErrors from '../modules/apierrors';
import getErrors from '../modules/geterrors';

class ModifyExercise extends Component {
  constructor(props) {
    super();

    this.state = {
      name: props.exercise.name,
      language: props.exercise.language,
      text: props.exercise.text,
      mode: props.exercise.mode,
      modifyExerciseDialog: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.exercises.hasUpdated && nextProps.exercises.hasUpdated) {
      this.setState({ modifyExerciseDialog: false });
    }
  }

  handleOpen = () => {
    this.setState({ modifyExerciseDialog: true });
  };

  handleClose = () => {
    this.setState({ modifyExerciseDialog: false });
  };

  handleLanguageChange = (event, index, language) => this.setState({ language });

  handleMode = (event, index, mode) => this.setState({ mode });

  handleInput = (event) => {
    this.setState({ name: event.target.value });
  }

  handleTextarea = (event) => {
    this.setState({ text: event.target.value });
  }

  render() {
    const { name, language, text, mode } = this.state;
    const id = this.props.exercise.id;

    const stats = {
      length: this.state.text.length,
      words: this.state.text.length === 0 ? (this.state.text.split(' ').length - 1) : this.state.text.split(' ').length,
    };

    const updateLabel = this.props.isWaiting ? <CircularProgress size={20} /> : 'Update exercise';


    const { validationErrors } = getErrors(this.props.errors);
    const nameErrorMessage = apiErrors[validationErrors.name] || validationErrors.name;
    const textErrorMessage = apiErrors[validationErrors.text] || validationErrors.text;

    const validSettings = this.state.name.length > 0 && this.state.text.length > 0;

    const disabled = !validSettings || this.props.disabledModify;

    const actions = [
      <FlatButton
        disabled={this.props.disabledModify}
        label="Cancel"
        primary
        onTouchTap={this.handleClose}
      />,
      <FlatButton
        disabled={disabled}
        label={updateLabel}
        primary
        onTouchTap={() => this.props.save(id, { name, language, text, mode })}
      />];

    return (
      <span>
        <RaisedButton label="Edit" onTouchTap={this.handleOpen} />
        <Dialog
          actions={actions}
          modal={false}
          open={this.state.modifyExerciseDialog}
          onRequestClose={this.handleClose}
        >
          <form>
            <TextField onChange={this.handleInput} ref={(input) => { this.exerciseName = input; }} errorText={nameErrorMessage} type="text" name="name" floatingLabelText="Exercise name" value={this.state.name} /><br />
            <SelectField
              floatingLabelText="Language"
              value={this.state.language}
              onChange={this.handleLanguageChange}
            >
              <MenuItem value="en-GB" primaryText="English (UK)" />
              <MenuItem value="en-US" primaryText="English (US)" />
              <MenuItem value="en-IN" primaryText="English (Indian)" />
              <MenuItem value="de-DE" primaryText="German" />
              <MenuItem value="es-ES" primaryText="Spanish" />
              <MenuItem value="es-US" primaryText="Spanish (US)" />
              <MenuItem value="fr-FR" primaryText="French" />
              <MenuItem value="hi-IN" primaryText="Hindi" />
              <MenuItem value="id-ID" primaryText="Indonesian" />
              <MenuItem value="it-IT" primaryText="Italian" />
              <MenuItem value="ja-JP" primaryText="Japanese" />
              <MenuItem value="ko-KR" primaryText="Korean" />
              <MenuItem value="nl-NL" primaryText="Dutch" />
              <MenuItem value="pl-PL" primaryText="Polish" />
              <MenuItem value="pt-BR" primaryText="Portuguese (Brazil)" />
              <MenuItem value="ru-RU" primaryText="Russian" />
              <MenuItem value="zh-CN" primaryText="Chinese" />
              <MenuItem value="zh-TW" primaryText="Chinese (Taiwan)" />
              <MenuItem value="zh-HK" primaryText="Chinese (Hong Kong)" />
            </SelectField>
            <br />
              <SelectField
                floatingLabelText="Mode"
                value={this.state.mode}
                onChange={this.handleMode}
              >
                <MenuItem value="normal" primaryText="Normal" />
                <MenuItem value="flipped" primaryText="Flipped" />
              </SelectField>
              <br />
            <textarea className="pronounce-exercise-text" value={this.state.text} onChange={this.handleTextarea} /><br />
            <div>{stats.length} characters - {stats.words} words</div>
            {textErrorMessage}
          </form>
        </Dialog>
      </span>

    );
  }
}

export default ModifyExercise;



// WEBPACK FOOTER //
// ./src/components/ModifyExercise.js